import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Projects API
export const projectsAPI = {
  getAll: async (featured = null) => {
    const params = featured !== null ? { featured } : {};
    const response = await axios.get(`${API}/projects`, { params });
    return response.data;
  },
  
  getFeatured: async () => {
    const response = await axios.get(`${API}/projects/featured`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/projects/${id}`);
    return response.data;
  }
};

// News API
export const newsAPI = {
  getAll: async (page = 1, limit = 6) => {
    const response = await axios.get(`${API}/news`, {
      params: { page, limit }
    });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/news/${id}`);
    return response.data;
  }
};

// Services API
export const servicesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/services`);
    return response.data;
  }
};

// Contact API
export const contactAPI = {
  submit: async (data) => {
    const response = await axios.post(`${API}/contact`, data);
    return response.data;
  }
};
